<!-- @format -->

<template>
  <a-tooltip placement="topLeft" :title="text">
    <div class="mixin-text-ellipse">{{ text || '--' }}</div>
  </a-tooltip>
</template>
<script>
/** @format */

export default {
  props: {
    text: String
  }
};
</script>
